import React, { useEffect, useState } from "react";
import axios from "axios";
import TopNav from "../../components/navigation/TopNav";
import { useTranslation } from "react-i18next";

import StandardScreen, { ScreenContent } from "../../components/layout/StandardScreen";
import Stack from "../../components/layout/Stack";
import Card from "../../components/ui/Card";
import FormField from "../../components/forms/FormField";
import TextInput from "../../components/forms/TextInput";

import {
  TableShell,
  Table,
  Th,
  Td,
} from "../../components/data/Table";

const narrowShellStyle = {
  width: "100%",
  margin: "0 auto",
};

export default function AdminDriversReport() {
  const { t } = useTranslation();

  const [drivers, setDrivers] = useState([]);
  const [textFilter, setTextFilter] = useState("");

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem("token")}`;

    axios
      .get(`${process.env.REACT_APP_API_URL}/admin/drivers`)
      .then((res) => setDrivers(Array.isArray(res.data) ? res.data : []))
      .catch((err) => {
        console.error("❌ Failed to fetch admin drivers report", err);
        setDrivers([]);
      });
  }, []);

  const formatDateTime = (value) => {
    if (!value) return "-";

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "-";

    return date
      .toLocaleString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      })
      .replace(",", "");
  };

  const getText = (value) => (value == null ? "" : String(value).toLowerCase());

  const filteredDrivers = drivers.filter((driver) => {
    const search = textFilter.toLowerCase().trim();

    return (
      search === "" ||
      getText(driver.driver_id).includes(search) ||
      getText(driver.vendor_id).includes(search) ||
      getText(driver.user_id).includes(search) ||
      getText(driver.fullname).includes(search) ||
      getText(driver.phone).includes(search) ||
      getText(driver.email).includes(search) ||
      getText(driver.status).includes(search) ||
      getText(driver.notes).includes(search)
    );
  });

  return (
    <StandardScreen
      topNav={<TopNav title={t("admin_drivers_report.title")} mode="main" />}
    >
      <ScreenContent>
        <div style={narrowShellStyle}>
          <Stack gap="4">
            <Card title={t("admin_drivers_report.title")}>
              <Stack gap="3">
                <FormField label={t("admin_drivers_report.fields.text_filter.label")}>
                  <TextInput
                    value={textFilter}
                    onChange={(e) => setTextFilter(e.target.value)}
                    placeholder={t("admin_drivers_report.fields.text_filter.placeholder")}
                  />
                </FormField>
              </Stack>
            </Card>

            <Card>
              <TableShell maxHeight="65vh">
                <Table>
                  <thead>
                    <tr>
                      <Th columnIndex={0} sticky wider>
                        {t("admin_drivers_report.table.driver_id")}
                      </Th>

                      <Th columnIndex={1} sticky wider>
                        {t("admin_drivers_report.table.fullname")}
                      </Th>

                      <Th wider>
                        {t("admin_drivers_report.table.user_id")}
                      </Th>

                      <Th wider>
                        {t("admin_drivers_report.table.vendor_id")}
                      </Th>

                      <Th wider>
                        {t("admin_drivers_report.table.phone")}
                      </Th>

                      <Th wider>
                        {t("admin_drivers_report.table.email")}
                      </Th>

                      <Th wider>
                        {t("admin_drivers_report.table.status")}
                      </Th>

                      <Th wider>
                        {t("admin_drivers_report.table.created_at")}
                      </Th>

                      <Th>
                        {t("admin_drivers_report.table.notes")}
                      </Th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredDrivers.map((driver) => (
                      <tr key={driver.driver_id}>
                        <Td columnIndex={0} sticky>
                          {driver.driver_id}
                        </Td>

                        <Td columnIndex={1} sticky wider>
                          {driver.fullname || "-"}
                        </Td>

                        <Td>{driver.user_id || "-"}</Td>
                        <Td>{driver.vendor_id || "-"}</Td>
                        <Td>{driver.phone || "-"}</Td>
                        <Td>{driver.email || "-"}</Td>
                        <Td>{driver.status || "-"}</Td>
                        <Td>{formatDateTime(driver.created_at)}</Td>
                        <Td>{driver.notes || "-"}</Td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </TableShell>
            </Card>
          </Stack>
        </div>
      </ScreenContent>
    </StandardScreen>
  );
}